export default __webpack_public_path__ + "static/media/cv151-6.c178e86b.png";